import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { IconsModule } from 'lib/modules/feather-icons.module';
import { ActiveTag } from './featured-solution-tags.util';

/**
 * Design-system "Featured Solution Tag": a tinted chip with a leading icon and a label.
 * Display only, no hover or click. Takes the already-filtered list from
 * `getActiveTags`, so it never has to know about expiry.
 *
 * The host is meant to be rendered unconditionally with `ngSkipHydration`, which keeps
 * the SSR DOM structure stable even when a tag expires between the cached server render
 * and browser hydration (see feature-solutions.component.html).
 */
@Component({
    selector: 'featured-solution-tags',
    templateUrl: './featured-solution-tags.component.html',
    styleUrls: ['./featured-solution-tags.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    // angular-feather bundles the SVGs in JS, so icons never depend on the resources CDN
    imports: [IconsModule],
})
export class FeaturedSolutionTagsComponent {
    @Input() tags: ActiveTag[] = [];
}
